import Vue from 'vue'
import VueRouter from 'vue-router'
// import store from '@/store'
// import api from '@/Api'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/',
    name: 'Index',
    component: () => import('../views/Index.vue'),
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/edit/:id',
    name: 'Edit',
    component: () => import('../views/Edit.vue'),
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/edit/:id/preview',
    name: 'Preview',
    component: () => import('../views/Preview.vue'),
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/page/:id',
    name: 'Page',
    component: () => import('../views/Page.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由全局监控
router.beforeEach((to, from, next) => {
  // 判断是否当前用户已登录
  const user = Vue.prototype.$app.auth().currentUser
  if (to.meta.requireAuth) {
    if (user) {
      next()
    } else {
      router.push({
        name: 'Login'
      })
    }
  } else {
    next()
  }
})

export default router
